<template>
  <a-modal
    width="960px"
    title="关联账户"
    v-model:visible="visible">
    <a-form
      ref="form"
      class="form"
      layout="inline"
      :rules="rules"
      :model="form">
      <div class="paragraph-title">
        <span>账号信息</span>
      </div>
      <a-form-item>
        <div class="teamMember-line">
          <span class="teamMember-label">账号</span>
          <a-auto-complete
          v-model:value="value"
          style="width: 200px"
          @select="onSelect"
          @search="handleSearch"
          option-label-prop="value">
        <template #dataSource>
          <a-select-option  v-for="item in dataSource" :value="item.userId" :key="item.userId" >
            {{item.username}}
          </a-select-option>
        </template>
        </a-auto-complete>
        </div>
        
      </a-form-item>
      <!-- {{teamRoles}} -->
      <div class="paragraph-title">
        <span>团队信息</span>
        <a-button @click="addToTeamRoles" type="primary" style="margin-left:10px;">增加团队角色</a-button>
      </div>
      <a-form-item name="status">
       
        <div
          class="teamMember-line"
          v-for="(tm, index) in teamRoles"
          :key="index">
          <span class="teamMember-label">团队</span>
          <a-select style="width: 200px"
            v-model:value="tm.teamId"
            :disabled="isTmr">
            <a-select-option
              v-for="item in validTeamList"
              :key="item.id"
              :disabled="item.state !== 'open'">
              {{ item.name }}
            </a-select-option>
          </a-select>
          <span class="teamMember-label">角色</span>
          <a-select style="width: 200px"
            v-model:value="tm.roleId">
            <a-select-option
              v-for="item in validRoleList"
              :key="item.roleId">
              {{ item.roleName }}
            </a-select-option>
          </a-select>
          <a-button
            @click="deleteFromTeamRoles(tm)"
            type="danger">删除</a-button>
          
        </div>
      </a-form-item>

 
    </a-form>
    <template #footer>
      <a-button key="submit" type="primary" @click="handleSubmit">
        保存
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import { mapState } from 'vuex'
import { accountList } from '@/api/user'
import { binding } from '@/api/team'
export default {
  data(){
    return{
      visible: false,
      value:'',
      name:'',
      userId:'',
      options:[],
      dataSource :[],
      fetching: false,
      teamRoles:[],
      rules: {
        value: [
          { required: true, message: '账号不能为空', trigger: 'blur' }
        ],


      },
    }
  },
  props:{
    currentItem: {
      type: Object,
      default: () => {}
    }
  },
  computed:{
    ...mapState(['currentRole', 'roleList', 'companyList', 'teamList']),
    validTeamList () {
      return this.teamList.filter(t => t.companyId === this.currentRole.companyId)
    },
    validRoleList () {
      const validRoleIds = []
      switch (this.currentRole.roleId) {
        case '7':
          validRoleIds.push(...['8', '9', '10', '11', '12'])
          break
        case '8':
          validRoleIds.push(...['9', '10', '11', '12'])
          break
        case '13':
          validRoleIds.push(...['14', '15','17','18'])
          break
        case '14':
          validRoleIds.push(...['15'])
          break
      }
      const result = this.roleList.filter(r => validRoleIds.indexOf(r.roleId) !== -1)
      return result
    },
    isTmr () {
      const tmgr = ['8', '14']
      return tmgr.indexOf(this.currentRole.roleId) !== -1
    }
  },
  created(){
    this.getAccountList()
  },
  methods:{
    open(){
      this.visible = true
      this.$nextTick(() => {
          this.teamRoles = []
          this.addToTeamRoles()
      })
    },
    onSelect(value){
      this.options.forEach((item)=>{
        if(item.userId == value){
          this.value = item.username
          this.userId = value
        }
      })      
    },
    handleSearch(val){
      let r = JSON.parse(JSON.stringify(this.options))
      let arr = []
      r.forEach((item)=>{
        if(item.username && item.username.includes(val)){
           arr.push(item)
        }
      })

      debugger
      if(val == ''){
        this.dataSource = r 
      }else{
        this.dataSource = arr
      }
    
    },
    async getAccountList(){
      debugger
      const {data:res} = await accountList({
        pageSize:999
      })
      let arr = []
      res.data.rows.forEach((element)=>{
        console.log(11)
        arr.push({
          value:element.name
        })
      });
      this.options = res.data.rows
      this.dataSource = JSON.parse(JSON.stringify(this.options))
    },
    addToTeamRoles () {
     const tr = {
        teamId: '',
        roleId: ''
      }
      if (this.isTmr) {
        tr.teamId = this.currentRole.teamId
      }
      this.teamRoles.push(tr)
    },
    deleteFromTeamRoles (tr) {
      const index = this.teamRoles.indexOf(tr)
      this.teamRoles.splice(index, 1)
    },
    async handleSubmit(){
      const isCompanyMgr = this.teamRoles.every((team)=>{
        return team.roleId != ''
      })
      if(this.userId == ''){
        this.$message.error('账户不能为空')
        return
      }
      if (!this.teamRoles.length || !isCompanyMgr) {
        this.$message.error('请配置团队角色')
        return
      }
    
      let roleIds = []
      this.teamRoles.forEach((team)=>{
        roleIds.push(team.roleId)
      })

      const {data:res} = await binding({
        roleIds,
        teamId:this.teamRoles[0].teamId,
        userId:this.userId,
      })

      if(res.state == 'success'){
        this.$emit('update')
        this.$message.success('操作成功')
        this.visible = false
      }

    }
  }
}
</script>

<style lang="less" scoped>
.form {
  // width: 900px; display: flex; flex-wrap: wrap;
  .paragraph-title {
    margin: 10px 0;
    //width: 100%;
   // display: flex;
    .ant-btn {
     // margin: 0 0 0 20px;
    }
  }
  .ant-form-item {
    margin: 10px 0;
    //width: 290px;
  }
  .user-ctrl {
    //width: 100%; text-align: right;
  }
  .teamMember-line {
    margin-bottom: 10px;
    // width: 100%; display: flex; align-items: center;
    .teamMember-label {
      margin-right: 10px;
      &::before {
        display: inline-block;
        margin-right: 4px;
        color: #ff4d4f;
        font-size: 14px;
        font-family: SimSun, sans-serif;
        line-height: 1;
        content: '*';
      }
    }
    .ant-select {
      margin-right: 20px;
    }
    .ant-btn {
      margin-right: 10px;
    }
  }
}
</style>